import * as Api from '@ViewModels';
import * as React from 'react';
import { useCompaniesQuery } from '../../../../queries';

interface ICompaniesSearchContext {
	sort: Api.ISortDescriptor;
	setSort(sort: Api.ISortDescriptor): void;
	companies: Api.ICompany[];
	companiesQuery: ReturnType<typeof useCompaniesQuery>;
	selectionState: Api.ESelectionState;
	selectedCompanyIds: string[];
	setSelectionState(state: Api.ESelectionState): void;
	setSelectedCompanyIds(ids: string[]): void;
	excludedCompanyIds: string[];
	setExcludedCompanyIds(ids: string[]): void;
}

interface ICompanyInputContext {
	search: string;
	setSearch(search: string): void;
	onSearchChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

export const CompaniesSearchInputContext = React.createContext<ICompanyInputContext>(null);
export const useCompaniesInput = () => {
	const context = React.useContext(CompaniesSearchInputContext);
	if (!context) {
		throw new Error('useCompaniesInput can only be used within the <CompaniesContainer /> component');
	}
	return context;
};

export const CompanySearchContext = React.createContext<ICompaniesSearchContext>(null);
export const useCompaniesSearch = () => {
	const context = React.useContext(CompanySearchContext);
	if (!context) {
		throw new Error('useCompaniesSearch can only be used within the <CompaniesContainer /> component');
	}
	return context;
};

/** What a company search matches until the user picks otherwise, and what clearing the search returns to. */
export const DefaultCompanySearchProperty = Api.CompanySearchRequestProperty.All;

export const DefaultCompaniesSort: Api.ISortDescriptor = {
	sort: 'asc',
	sortBy: 'companyName',
};
